import React, { useState, useEffect, useImperativeHandle } from 'react';
import * as NUMBER from '../../src/common/constants/number';

const useSlider = (containerRef, countElements, data, type, autoplaySpeed, onChangeCurrentIndex) => {
  const [viewed, setViewed] = useState(0);
  const [distance, setDistance] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [slideItemPadding, setSlideItemPadding] = useState(0);

  const [totalInViewport, setTotalInViewport] = useState(1);
  const [slideCount, setSlideCount] = useState(1);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [sliderPages, setSliderPages] = useState(countElements);
  const [autoplay, setAutoPlay] = useState(true);
  const [userInteraction, setUserInteraction] = useState(false);
  const [directClickautoPlayCheck, setDirectClickautoPlayCheck] = useState(false);
  const [autoplayCheckMouseOn, setAutoplayCheckMouseOn] = useState(false);
  const [mainPauseCheck, setMainPauseCheck] = useState(false);

  const directClickautoPlay = (val) => {
    if (val === false) {
      setMainPauseCheck(true);
      setAutoPlay(false);
      setDirectClickautoPlayCheck(true);
    } else {
      setMainPauseCheck(false);
      setAutoPlay(true);
      setDirectClickautoPlayCheck(false);
    }
  };

  useEffect(() => {
    if (containerRef.current && countElements > 0) {
      const containerWidth = containerRef.current.clientWidth;
      const itemWidth = containerRef.current.firstChild ? containerRef.current.firstChild.clientWidth : containerWidth;
      const totalInViewport = (type === 'poster') ? 5 : Math.ceil(containerWidth / itemWidth);
      const slideCount = Math.ceil(countElements / totalInViewport);

      switch (type) {
        case 'poster':
          setSlideItemPadding(NUMBER.SLIDE_PADDING_BOX_TYPE_POSTER);
          break;
        case 'event':
          setSlideItemPadding(NUMBER.SLIDE_PADDING_BOX_TYPE_EVENT);
          break;
        case 'schedule':
          setSlideItemPadding(NUMBER.SLIDE_PADDING_BOX_TYPE_SCHEDULE);
          break;
        default:
          setSlideItemPadding(NUMBER.SLIDE_PADDING_BOX_TYPE_DEFAULT);
          break;
      }

      setSlideCount(slideCount);
      setContainerWidth(containerWidth);
      setTotalInViewport(totalInViewport);

      // 여백때문에 위 계산이 안맞는듯하여 그냥 하드코딩

      setSliderPages(Math.ceil(countElements / totalInViewport)); // 데이터주는 slider쪽에서 countElements 넘겨준걸 나누기로 함
    }
  }, [containerRef, data, countElements, type]);

  useEffect(() => {
    if (autoplaySpeed > 0) {
      if (!autoplay) return () => clearTimeout(tick);
      const tick = setTimeout(() => {
        moveSlide('right');
      }, autoplaySpeed);
      return () => clearTimeout(tick);
    }
  }, [sliderIndex, autoplay]);

  useEffect(() => {
    setTimeout(() => {
      if (userInteraction) {
        const focusToElem = containerRef.current?.children[viewed].querySelector('a') ||
          containerRef.current?.children[viewed].querySelector('em') ||
          containerRef.current?.children[viewed].querySelector('font') ||
          containerRef.current?.children[viewed].querySelector('div') ||
          containerRef.current?.children[viewed].querySelector('button');
        focusToElem?.focus();
        focusToElem?.blur();
        setUserInteraction(false);
      }
    }, NUMBER.DELAY_MOVE_FOCUS);
  }, [viewed]);

  const slideProps = {
    style: { transform: `translate3d(${distance}px, 0, 0)`, transition: 'all .3s ease-in-out' }
  };

  const paginationIndicator = (nPages) => {
    const paginationList = [];
    for (let i = 0; i < nPages; i++) {
      if (sliderIndex === i) {
        paginationList.push(<li className='slide_dots current' key={i} />);
      } else {
        paginationList.push(<li className='slide_dots' key={i}><i className='hide'>{sliderIndex} 페이지</i></li>);
      }
    }
    return paginationList;
  };

  const bigPaginationIndicator = (nPages) => {
    const paginationList = [];
    for (let i = 0; i < nPages; i++) {
      if (sliderIndex === i) {
        paginationList.push(
          <li onClick={() => clickPageIndicator(i)} className='mvsp_list_inner current' key={i}>
            {/* “선택됨, 3페이지 링크” */}
            <button type='button' className='mvsp_list_btn' aria-label={'"선택됨, ' + `${(i + 1)} 페이지 링크"`}><span className='ir'>슬라이드 {(i + 1)} 페이지</span></button>
          </li>
        );
      } else {
        paginationList.push(
          <li onClick={() => clickPageIndicator(i)} className='mvsp_list_inner' tabIndex='-1' key={i}>
            <button type='button' className='mvsp_list_btn' aria-label={'"' + `${(i + 1)} 페이지 링크"`}><span className='ir'>슬라이드 {(i + 1)} 페이지 </span></button>
          </li>
        );
      }
    }
    return paginationList;
  };

  function autoplayCheckPause () { // 마우스가  좌우 버튼 및  라이브 보기 버튼  최신 클립 영역에 있을시 아이콘 모양 바꾸지 않기위한 함수
    if (autoplayCheckMouseOn === true) {
      if (autoplay === true) {
        return 'mvsp_btn_play';
      } else {
        return 'mvsp_btn_play current';
      }
    } else {
      if (autoplay === true) {
        return 'mvsp_btn_play current';
      } else {
        return 'mvsp_btn_play';
      }
    }
  }

  function autoplayCheckPlay () { // 마우스가  좌우 버튼 및  라이브 보기 버튼  최신 클립 영역에 있을시 아이콘 모양 바꾸지 않기위한 함수
    if (autoplayCheckMouseOn === true) {
      if (autoplay === false) {
        return 'mvsp_btn_pause';
      } else {
        return 'mvsp_btn_pause current';
      }
    } else {
      if (autoplay === false) {
        return 'mvsp_btn_pause current';
      } else {
        return 'mvsp_btn_pause';
      }
    }
  }

  const bigPaginationAutoButton = () => {
    const buttonList = [];
    buttonList.push(
      <button key='0' aria-label='슬라이드 자동 재생멈춤' onClick={() => directClickautoPlay(false)} type='button' className={`${autoplayCheckPause()}`}>
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
          <path className='mvsp_pause' d='M11,3a8,8,0,1,0,8,8A8,8,0,0,0,11,3Zm-.8,11.2H8.6V7.8h1.6Zm3.2,0H11.8V7.8h1.6Z' transform='translate(-3 -3)' />
        </svg>
        <i className='hide'>슬라이드 자동 재생</i>
      </button>
    );
    buttonList.push(
      <button key='1' aria-label='슬라이드 자동 재생' onClick={() => directClickautoPlay(true)} type='button' className={`${autoplayCheckPlay()}`}>
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
          <path className='mvsp_play' d='M11,3a8,8,0,1,0,8,8A8,8,0,0,0,11,3ZM9.4,14.6V7.4L14.2,11Z' transform='translate(-3 -3)' />
        </svg>
        <i className='hide'>슬라이드 자동 재생멈춤</i>
      </button>
    );
    return buttonList;
  };

  let clickPageIndicatorCheck;
  const clickPageIndicator = (index) => { // 메인화면 탑 부분 jumbotron 부분 에서  ... 페이징 이벤트 처리하는  부분
    setViewed(index);
    setSliderIndex(index);
    setUserInteraction(true);
    if (typeof onChangeCurrentIndex === 'function') {
      onChangeCurrentIndex(index);
    }
    clickPageIndicatorCheck = true;
  };

  const moveSlide = (direction, action) => {
    let currentSliderIndex = 0;
    // //console.log('find data left lst distance : ' + distance);
    // //console.log('find data left lst containerWidth : ' + containerWidth); /// 박스가 모여있는 사이즈   ??? 25는 무엇 ?
    // //console.log('find data left lst slideItemPadding : ' + slideItemPadding); // 이아이가 패딩 값 25

    const maxSize = (containerWidth + slideItemPadding) * (slideCount - 1) * -1;
    if (direction === 'right') {
      const moveSize = distance - containerWidth - slideItemPadding;
      const isEdge = viewed + totalInViewport >= data.length;
      // //console.log('find data maxSize : ' + maxSize);
      if (isEdge) {
        setViewed(0);
        setDistance(0);
        currentSliderIndex = 0;
        // //console.log('find data right lst viewed : ' + viewed);
        // //console.log('find data right lst totalInViewport : ' + totalInViewport);
        // //console.log('find data right lst moveSize : ' + moveSize);
      } else {
        const view = viewed + totalInViewport;
        setViewed(view);
        setDistance(moveSize);
        currentSliderIndex = sliderIndex + 1;
        // //console.log('find data right olst viewed : ' + viewed);
        // //console.log('find data right olst totalInViewport : ' + totalInViewport);
        // //console.log('find data right olst moveSize : ' + moveSize);
      }
    } else if (direction === 'left') {
      const moveSize = distance + containerWidth + slideItemPadding;
      if (viewed - totalInViewport < 0) {
        currentSliderIndex = slideCount - 1; // 슬라이드 위치 제어 점찍히는 부분
        setViewed(currentSliderIndex * totalInViewport); // 마지막 점에서 초기화 값 찍어주는 부분
        setDistance(maxSize); // 돌리는 부분
      } else {
        setViewed(viewed - totalInViewport);
        setDistance(moveSize);
        currentSliderIndex = sliderIndex - 1;
      }
    } else if (direction === 'pause') {
      if (directClickautoPlayCheck !== true) {
        setAutoPlay(false);
        currentSliderIndex = sliderIndex;
      } else {
        return;
      }
    } else if (direction === 'play') {
      if (directClickautoPlayCheck !== true) {
        setAutoPlay(true);
        setMainPauseCheck(false);
        setAutoplayCheckMouseOn(false);
        currentSliderIndex = sliderIndex;
      } else {
        return;
      }
    } else if (direction === 'onmouse_pause') {
      if (mainPauseCheck === true) {
        return;
      }
      setAutoPlay(false);
      setAutoplayCheckMouseOn(true);
      currentSliderIndex = sliderIndex;
    }

    setSliderIndex(currentSliderIndex); // 이게 문제임

    if (action) setUserInteraction(true);

    if (typeof onChangeCurrentIndex === 'function') {
      onChangeCurrentIndex(currentSliderIndex);
    }
  };

  return { moveSlide, sliderIndex, slideCount, sliderPages, slideProps, paginationIndicator, bigPaginationIndicator, bigPaginationAutoButton, totalInViewport, clickPageIndicatorCheck };
};

export default useSlider;
